


























































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { compileGetter } from 'devextreme/utils';
import {
    DxSelectBox,
    DxDateBox,
    DxNumberBox,
    DxValidator,
    DxValidationGroup,
    DxScrollView,
} from 'devextreme-vue';
import { DxRequiredRule, DxCompareRule } from 'devextreme-vue/validator';
import ValidationEngine from 'devextreme/ui/validation_engine';

import { SettingsState } from '@/store';
import { localize } from '@/core/filters';
import { Inject, ClientDate } from '@/core/helpers';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';
import {
    LocalizationKeys,
    IRelocationLimitFormData,
    RelocationLimitFormData,
    RelocationLimit,
    RelocationLimitFormMode,
    EditedRelocationLimit,
    Channel,
    ComponentData,
} from '../classes';

@Component({
    components: {
        DxSelectBox,
        DxDateBox,
        DxNumberBox,
        DxValidator,
        DxScrollView,
        DxRequiredRule,
        DxCompareRule,
    },
})
export default class RelocationLimitForm extends Vue {
    @Prop({ type: Object, required: true })
    public data?: IRelocationLimitFormData;

    private LocalizationKeys = LocalizationKeys;
    private localize = localize;

    private showError: boolean = false;
    private errorText: string = '';

    private dateStart: Date | null = null;
    private dateEnd: Date | null = null;

    private created(): void {
        if (!this.data) {
            throw new Error('data has not been set');
        }
        if (!this.data.closeForm) {
            throw new Error('data.closeForm has not been set');
        }

        if (this.data.relocationLimit) {
        } else {
            this.data.relocationLimit = EditedRelocationLimit.createDefault();
        }

        this.getRelocationLimitDates();
    }

    private get channelsDataSource(): DataSource {
        const me = this;

        const store = new CustomStore({
            load: () => this.data!.channels,
            loadMode: 'raw',
            useDefaultSearch: true,
        });
        // TODO: paging
        const dataSource = new DataSource({
            paginate: false,
            store,
        });

        return dataSource;
    }

    private get channel(): Channel | undefined {
        return this.data!.relocationLimit!.channel;
    }
    private set channel(channel: Channel | undefined) {
        this.data!.relocationLimit!.channel = channel;
    }
    private get weightLimit(): number | null {
        return this.data!.relocationLimit!.weightLimit;
    }
    private set weightLimit(value: number | null) {
        this.data!.relocationLimit!.weightLimit = value;
    }
    private get volumeLimit(): number | null {
        return this.data!.relocationLimit!.volume;
    }
    private set volumeLimit(value: number | null) {
        this.data!.relocationLimit!.volume = value;
    }

    private onRepeateClick(): void {
        this.saveForm();
    }
    private onOkClick(): void {
        this.saveForm();
    }
    private onCancelClick(): void {
        this.data!.closeForm(false);
    }

    private getRelocationLimitDates(): void {
        const startDate = this.data!.relocationLimit!.startDate;
        this.dateStart = this.toDevExtremeDate(startDate);

        const endDate = this.data!.relocationLimit!.endDate;
        this.dateEnd = this.toDevExtremeDate(endDate);
    }
    private setRelocationLimitDates(): void {
        const dateStart = this.fromDevExtremeDate(this.dateStart);
        this.data!.relocationLimit!.startDate = dateStart;

        const dateEnd = this.fromDevExtremeDate(this.dateEnd);
        this.data!.relocationLimit!.endDate = dateEnd;
    }
    private toDevExtremeDate(date: ClientDate | null): Date | null {
        let result;

        if (date) {
            const clientOffset =
                SettingsState.contextSettings.global.timeOffset || 0;
            result = date.toDate();
            const timeOffset = result.getTimezoneOffset() / 60;
            result.setTime(
                result.getTime() + (timeOffset - clientOffset) * 60 * 60 * 1000
            );
        } else {
            result = null;
        }

        return result;
    }
    private fromDevExtremeDate(value: Date | null): ClientDate | null {
        let result;

        if (value) {
            const clientOffset =
                SettingsState.contextSettings.global.timeOffset || 0;
            const timeOffset = value.getTimezoneOffset() / 60;
            const dateJs = new Date(
                value.getTime() - (timeOffset - clientOffset) * 60 * 60 * 1000
            );
            result = new ClientDate(dateJs.toISOString());
        } else {
            result = null;
        }

        return result;
    }
    private async saveForm(): Promise<void> {
        try {
            this.hideError();
            const validationResult = ValidationEngine.validateGroup();
            if (validationResult.isValid) {
                this.setRelocationLimitDates();
                await this.data!.save();
                this.data!.closeForm(true);
            }
        } catch (ex) {
            this.displayError(ex);
        }
    }
    private displayError(ex: any): void {
        this.errorText = ex.toString();
        this.showError = true;
    }
    private hideError(): void {
        this.showError = false;
        this.errorText = '';
    }
}
